import FacilityList from './FacilityList';

export default {
  list: FacilityList,
};
